import { Col } from "antd";
import { Fade } from "react-awesome-reveal";
import { withTranslation } from "react-i18next";
import { ContentBlockProps } from "./types";

import {
    ContentSection,
    MinPara,
    MinKeywords,
    StyledRow,
    CoreTitle,
    ImageWrapper,
    BubbleCard
} from "./styles";

const BubbleBlock = ({
    text1,
    text2,
    text3,
    t,
    id,
    direction
}: ContentBlockProps) => {

    return (
        <ContentSection>
            <Fade direction={direction} triggerOnce>
                <StyledRow
                    justify="space-between"
                    align="middle"
                    id={id}
                    direction={direction}
                >
                    <Col>
                        <ImageWrapper>
                            <img src={"/img/patients.png"} alt="Section visual" />
                        </ImageWrapper>
                        <BubbleCard id={id} direction={direction}>
                            <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'center' }}>
                                <CoreTitle>{t(text1)}</CoreTitle>
                                <MinKeywords>{t(text2)}</MinKeywords>
                                <MinPara>{t(text3)}</MinPara>
                            </Col>
                        </BubbleCard>
                    </Col>
                </StyledRow>
                
            </Fade>
        </ContentSection>
    );
};

export default withTranslation()(BubbleBlock);
